import * as Chart from 'chart.js';
import {DataModel} from '../model/base/data.model';
import {ChartTypeDataInterface} from '../model/interface/chart-type-data-interface';

export class ChartRenderer {

    static render(type: ChartTypeDataInterface, id: any, data: DataModel): Array<any>{

        return new Chart(id, {
            type: type.id,
            data: data.toJSON(type.additionalData),
            options: type.option
        });
    }

    static shift(chart : Chart)
    {
        let data = chart.config.data;

        let datasets = data.datasets;
        let labels = data.labels;

        for(let i = 0; i < datasets.length; i++)
        {
            let set = datasets[i].data;

            for(let j = 1; j < set.length; j++)
            {
                set[j - 1] = set[j];
            }

            datasets[i].data = set;
        }

        // console.log(chart.config.data);
        chart.update();
    }

    static update(chart : Chart)
    {
        chart.update();
    }

    static addData(chart: Chart, values: number[])
    {
        let datasets = chart.config.data.datasets;

        for(let i = 0; i < datasets.length; i++)
        {
            let set = datasets[i].data;

            set[set.length - 1] = values[i];
        }
    }



}



// WEBPACK FOOTER //
// ./src/app/components/charts/chart/controller/chart.renderer.ts